import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { Drawer, Grid, Typography, Button, Hidden } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/DeleteOutline';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(2)
  },
  actions: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    '& > * + *': {
      marginLeft: theme.spacing(2)
    }
  },
  buttonIcon: {
    marginRight: theme.spacing(1)
  }
}));

const TableEditBar = props => {
  const {
    selected,
    className,
    onMarkShow,
    onMarkHide,
    onDelete,
    ...rest
  } = props;

  const classes = useStyles();
  const { t } = useTranslation('common');
  const open = selected.length > 0;

  return (
    <Drawer
      anchor="bottom"
      open={open}
      // eslint-disable-next-line react/jsx-sort-props
      PaperProps={{ elevation: 1 }}
      variant="persistent"
    >
      <div
        {...rest}
        className={clsx(classes.root, className)}
      >
        <Grid
          alignItems="center"
          container
          spacing={2}
        >
          <Hidden smDown>
            <Grid
              item
              md={3}
            >
              <Typography
                color="textSecondary"
                variant="subtitle1"
              >
                {t('indicator.selected', { name: selected.length })}
              </Typography>
            </Grid>
          </Hidden>
          <Grid
            item
            md={6}
            xs={12}
          >
            <div className={classes.actions}>
              {onMarkShow && (
                <Button onClick={onMarkShow}>
                  <VisibilityIcon className={classes.buttonIcon} />
                  {t('mark.show')}
                </Button>
              )}
              {onMarkHide && (
                <Button onClick={onMarkHide}>
                  <VisibilityOffIcon className={classes.buttonIcon} />
                  {t('mark.hide')}
                </Button>
              )}
              {onDelete && (
                <Button onClick={onDelete}>
                  <DeleteIcon className={classes.buttonIcon} />
                  {t('mark.delete')}
                </Button>
              )}
            </div>
          </Grid>
        </Grid>
      </div>
    </Drawer>
  );
};

TableEditBar.propTypes = {
  className: PropTypes.string,
  onDelete: PropTypes.func,
  onMarkShow: PropTypes.func,
  onMarkHide: PropTypes.func,
  selected: PropTypes.array.isRequired
};
TableEditBar.defaultProps = {
  onDelete: () => {},
  onMarkShow: () => {},
  onMarkHide: () => {},
  selected: []
};

export default TableEditBar;
